import { Link } from 'react-router-dom';
import { aboutInfo } from '@/mocks/about';

const footerLinks = {
  categories: [
    { label: '家居好物', path: '/category/家居好物' },
    { label: '时尚精品', path: '/category/时尚精品' },
    { label: '生活优选', path: '/category/生活优选' },
    { label: '特惠专区', path: '/category/特惠专区' },
  ],
  about: [
    { label: '品牌故事', path: '/about' },
    { label: '精选文章', path: '/articles' },
    { label: '联系我们', path: '/about#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-foreground-950">久久精品</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              品质经久不衰的精选好物平台。
              <br />
              严苛品控，只为甄选每一件经得起时间考验的精品。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-reddit-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">精选品类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">关于久久</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line mt-0.5 text-foreground-400"></i>
                <a href={`mailto:${aboutInfo.contact.email}`} className="hover:text-primary-600 transition-colors cursor-pointer">
                  {aboutInfo.contact.email}
                </a>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-phone-line mt-0.5 text-foreground-400"></i>
                <span>{aboutInfo.contact.phone}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line mt-0.5 text-foreground-400"></i>
                <span className="leading-relaxed">{aboutInfo.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 久久精品 版权所有 | 品质经久不衰
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">退货政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}